export interface GetAlarmsArgs {
    customerId: number;
    StartTime?: string;
    EndTime?: string;
    LocationIds?: Array<number>;
    LocationGroupID?: number;
    Active?: boolean;
    Acknowledged?: boolean;
    Cleared?: boolean;
    UserIds?: Array<number>;
    AlarmDefinitionIds?: Array<number>;
    IncludeInactiveLocations?: boolean;
}

export interface AlarmsTotal {
    alarmstotal: number;
    timestamp: string;
}

export enum AlarmTypes {
    NONE = 0,
    LOW_BATTERY_ALARM = 1,
    HIGH_HIGH_ALARM = 2,
    HIGH_LEVEL_ALARM = 3,
    LOW_LEVEL_ALARM = 4,
    RAIN_ALARM = 5,
    LOW_FLOW_ALARM = 7,
    SUBMERGED_ALARM = 8,
    TILT_ALARM = 10,
    FULL_PIPE_ALARM = 11,
    OVERFLOW_ALARM = 12,
    WET_OVERFLOW_ALARM = 13,
    DRY_OVERFLOW_ALARM = 14,
    HIGH_FLOW_ALARM = 15
}

export enum DailyReportTypes {
    COMMUNICATION = 0,
    LOW_BATTERY = 1,
}

export interface AcknowledgeAlarms {
    startTime?: string,
    endTime?: string,
    locationIds?: number[],
    locationGroupId?: number,
    alarmDefinitionIds?: number[]
    includeInactiveLocations?: boolean
}

export interface AlarmTypesResponse {
    id: number;
    entityID: number;
    description: string;
}

export enum AlarmResponseMessage {
    AlarmCleared = 'Alarm cleared',
    AlarmAcknowledged = 'Alarm acknowledged'
}

export enum AlarmState {
    Unacknowledged = 0,
    Acknowledged = 1,
    Cleared = 2
}

export interface UpdateAlarmsResponse {
  responseMessage: AlarmResponseMessage;
  alarm: Alarm;
}

export interface Alarm {
  alarmDefinitionID: number;
  state: AlarmState;
  type: string;
  customerID: number;
  locationID: number;
  location: string;
  alarmAddress: string;
  timestamp: string;
  acknowledgeBy: string;
  acknowledgeTime: string;
  clearBy?: string;
  clearTime?: string;
  processedNotification: boolean;
  processedAnalysis: boolean;
  alarmID: number;
}

export interface DailyAlarmType {
    name: string;
    id: DailyReportTypes;
}
